<template>
    <div class="flexbox height100">
        <h1 class="flex-margin-auto up20">Coming Soon</h1>
    </div>
</template>

<script>
export default {
    data () {
        return {
            msg: "Coming Soon",
        };
    },
};
</script>
<style scoped>
	.up20{
		transform: translateY(-20%);
	}
</style>


// WEBPACK FOOTER //
// src/components/Analysis/ComingSoonAnalysis.vue